export default __webpack_public_path__ + "static/media/image.neo-minds-holdings-pvt-ltd.191d519f.png";